<div>
  <h6 class="odx-title-6" i18n="@@global.cableRoutes">Kabeltrassen</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addCableRoute()"
      [odxTooltip]="tooltipTextAddCableRoute"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragCableRoute()"
    ></app-add-button>
    <app-toggle-visibility-button
      [visible]="floorplanState.cableRoutesVisible"
      (toggleEvent)="floorplanState.cableRoutesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.cableRoutesItemTextVisible"
      (toggleEvent)="updateCableRoutesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button [locked]="floorplanState.cableRoutesLocked" (toggleEvent)="floorplanState.cableRoutesLocked = $event">
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
